<template>
  <VDialogV3
    id="shipment-assembly-variant-popup"
    width="400px"
    title="Валюта и НДС отгрузки"
    :submit-disabled="selectedVariant === null"
    :loading="false"
    @submit="submit"
  >
    <section>
      <p>
        В сборке есть позиции в разных валютах или с разным типом НДС.
        В одну отгрузку попадут позиции только одного варианта.
      </p>

      <VSelectV2
        v-model="selectedVariant"
        label="Вариант"
        layout="vertical"
        required
        :data="variants"
      />
    </section>
  </VDialogV3>
</template>

<!-- Выбор валюты и типа НДС для отгрузки по сборке -->

<script lang="ts">
import type ShipmentAssemblyVariant from '@/domains/Shipments/ShipmentAssemblyVariant';

export default defineComponent({
  name: 'ShipmentAssemblyVariantPopup',

  props: {
    /** Варианты «валюта + тип НДС» неотгруженных позиций сборки (Shipment.getAssemblyVariants) */
    variants: {
      type:     Array as PropType<ShipmentAssemblyVariant[]>,
      required: true,
    },
  },

  emits: ['selected'],

  data() {
    return {
      selectedVariant: null as ShipmentAssemblyVariant | null,
    };
  },

  methods: {
    submit() {
      this.$emit('selected', this.selectedVariant);
      this.$core.dialogs.ShipmentAssemblyVariantPopup.hide();
    },
  },
});
</script>
